import React, { useRef, useEffect, useState } from "react";
import {
  FiPlay,
  FiGlobe,
  FiX,
  FiFolder,
  FiFileText,
  FiSave,
  FiClock,
  FiRotateCcw,
  FiRotateCw,
  FiSearch,
  FiAlignLeft,
  FiMessageSquare,
  FiArrowLeft,
  FiPlus,
  FiUpload,
  FiUser,
  FiCheck,
  FiEdit,
  FiChevronDown,
  FiDownload,
  FiTrash2,
  FiEye,
  FiDatabase,
  FiKey,
  FiCheckSquare,
  FiSquare,
  FiCheckCircle,
  FiXCircle,
  FiCopy,
} from "react-icons/fi";
import Editor, { DiffEditor } from "@monaco-editor/react";
import { useNavigate } from "react-router-dom";

import SAFM from "../libs/Safm";
import { Images } from "../libs/FileTypes";
import He from "../libs/He";
import PagePreview from "../libs/PagePreview.js";

import ConfirmedImg from "../img/confirmed.svg";
import UploadImg from "../img/upload.svg";

import {
  ContextMenu,
  ContextMenuItem,
  FileIcon,
  InputField,
  Modal,
  ModalBody,
  ModalButton,
  ModalFooter,
  ModalHeader,
  ModalInput,
  Spinner,
  Splitter,
  Tab,
  ToolbarButton,
} from "../Components/Components";

import "../App.css";

const darkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

let currentFile = null;
let currentCode = null;
let eventSource = null;
let draggingTab = null;
let focusedTab = null;
let resizing = false;
let lastPath = "";
let restored = false;

let Domains = {};
let Languages = {};

const Home = () => {
  const useIsVisible = (elementRef, i) => {
    useEffect(() => {
      if (elementRef.current) {
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setFileIndex((fileIndex) => fileIndex + i);
              }
            });
          },
          {
            root: null,
            rootMargin: "40px 0px 0px 0px",
            threshold: 0,
          }
        );
        observer.observe(elementRef.current);
      }
    }, [elementRef]);
  };

  const addFileItemRef = useRef();
  useIsVisible(addFileItemRef, 1);

  const fileContextMenuRef = useRef(null);
  const folderContextMenuRef = useRef(null);

  const navigate = useNavigate();

  const [isOnline, setIsOnline] = useState(true);
  const [status, setStatus] = useState("Pronto");
  const [uploading, setUploading] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [editors, setEditors] = useState({});
  const [fileIndex, setFileIndex] = useState(0);

  const [listOfTables, setListOfTables] = useState({ columns: [], data: [[]] });
  const [listOfFields, setListOfFields] = useState({ columns: [], data: [[]] });
  const [listOfTop1000, setListOfTop1000] = useState({ columns: [], data: [[]] });
  const [filteredListOfTables, setFilteredListOfTables] = useState({ data: [[]] });
  const [selectedTable, setSelectedTable] = useState("");

  const [tabs, setTabs] = useState([
    {
      id: 0,
      key: 0,
      name: "Lista pagine",
      dismissable: false,
      screen: 0,
    },
  ]);

  const [screens, setScreens] = useState([
    {
      id: 0,
      key: 0,
      activeTab: 0,
    },
  ]);

  const [currentPath, setCurrentPath] = useState("");
  const [currentAuthor, setCurrentAuthor] = useState("");
  const [publish, setPublish] = useState(false);
  const [publishNotes, setPublishNotes] = useState("");
  const [domainMenu, setDomainMenu] = useState(false);
  const [createMenu, setCreateMenu] = useState(false);
  const [userMenu, setUserMenu] = useState(false);

  const [files, setFiles] = useState([]);
  const [openFiles, setOpenFiles] = useState([]);
  const [pubFiles, setPubFiles] = useState([]);
  const [navigationHistory, setNavigationHistory] = useState([]);
  const [fileHistory, setFileHistory] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [createFileName, setCreateFileName] = useState("");
  const [createFolderName, setCreateFolderName] = useState("");
  const [removeFilePath, setRemoveFilePath] = useState("");
  const [removeFolderPath, setRemoveFolderPath] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [promptTitle, setPromptTitle] = useState("");
  const [promptMessage, setPromptMessage] = useState("");
  const [promptResult, setPromptResult] = useState(true);
  const [otp, setOtp] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [text, setText] = useState("");

  const [fileBeingEditedModal, setFileBeingEditedModalVisible] = useState(false);
  const [renameFileModal, setRenameFileModal] = useState(false);
  const [renameFolderModal, setRenameFolderModal] = useState(false);
  const [removeFileModal, setRemoveFileModal] = useState(false);
  const [removeFolderModal, setRemoveFolderModal] = useState(false);
  const [createFileModal, setCreateFileModal] = useState(false);
  const [createFolderModal, setCreateFolderModal] = useState(false);
  const [openFilesModal, setOpenFilesModal] = useState(false);
  const [fileDiffsModal, setFileDiffsModal] = useState(false);
  const [fileHistoryModal, setFileHistoryModal] = useState(false);
  const [filePublishedModal, setFilePublishedModal] = useState(false);
  const [discardChangesModal, setDiscardChangesModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [pathModal, setPathModal] = useState(false);
  const [tablesModal, setTablesModal] = useState(false);
  const [fieldsModal, setFieldsModal] = useState(false);
  const [top1000Modal, setTop1000Modal] = useState(false);
  const [settingsModal, setSettingsModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [promptModal, setPromptModal] = useState(false);
  const [searchTextModal, setSearchTextModal] = useState(false);
  const [previewFile, setPreviewFile] = useState({ type: null, path: null });

  const [fileContextMenu, setFileContextMenu] = useState(false);
  const [folderContextMenu, setFolderContextMenu] = useState(false);
  const [fileContextMenuPosition, setFileContextMenuPosition] = useState({ top: 0, left: 0 });
  const [folderContextMenuPosition, setFolderContextMenuPosition] = useState({ top: 0, left: 0 });

  const [diffs, setDiffs] = useState([]);

  const [newFileName, setNewFileName] = useState("");
  const [oldFileName, setOldFileName] = useState("");
  const [newFolderName, setNewFolderName] = useState("");
  const [oldFolderName, setOldFolderName] = useState("");
  const [dropFilesVisible, setDropFilesVisible] = useState(false);
  const [pageList, setPageList] = useState("open");

  const [elementPath, setElementPath] = useState("");
  const [showPagePreview, setShowPagePreview] = useState(false);

  const handleEditorDidMount = (editor, monaco, screenId, tabId) => {
    let list = editors;

    if (!list[screenId]) {
      list[screenId] = [];
    }

    list[screenId][tabId] = editor;
    setEditors(list);

    if (darkMode) {
      monaco.editor.defineTheme("my-theme", {
        base: darkMode ? "vs-dark" : "vs-light",
        inherit: true,
        rules: [{ background: "1e1e22" }],
        colors: {
          "editor.background": "#1e1e22",
        },
      });
      monaco.editor.setTheme("my-theme");
    }

    const companyDomain = window.localStorage.getItem("companyDomain");
    const viewState = window.localStorage.getItem(`viewState${screenId}-${tabId}-${companyDomain}`);
    if (viewState) {
      editor.restoreViewState(JSON.parse(viewState));
    }

    editor.onDidFocusEditorWidget(() => {
      focusedTab = tabId;
    });
  };

  const eventSourceListener = (list, path) => {
    if (eventSource) eventSource.close();

    const originalPath = path;

    path = path.replace(/\//g, "-");
    path = path.replace(/\./g, "");
    path = path.replace(/:/g, "");
    path = path.toLowerCase();

    const now = new Date();

    const companyDomain = window.localStorage.getItem("companyDomain");
    const dbId = companyDomain.toLowerCase().replace("https://", "").replace(/\./g, "-").replace("-cedolino-net", "").replace("/app/", "");

    eventSource = new EventSource(`https://testnotifiche-c4713-default-rtdb.firebaseio.com/${dbId}/files/${path}.json`);
    eventSource.addEventListener("put", (e) => {
      const { data } = JSON.parse(e.data);

      if (data && data.user !== SAFM.getUserObject().usr.toLowerCase()) {
        const { update } = data;

        const date = update.split(" ")[0];
        const time = update.split(" ")[1];

        const yyyy = date.split("/")[2];
        const mm = date.split("/")[1];
        const dd = date.split("/")[0];

        const datetime = `${yyyy}-${mm}-${dd} ${time}`;
        const dateLastUpdate = new Date(datetime);

        if (dateLastUpdate.getTime() > now.getTime()) {
          updateFilesState(list, originalPath);
        }
      }
    });
  };

  const dismissMenus = (e) => {
    setFileContextMenu(false);
    setPathModal(false);
    setFileContextMenu(false);
    setFolderContextMenu(false);
    if (!e) {
      setDomainMenu(false);
      setCreateMenu(false);
      setUserMenu(false);
    } else {
      if (e.target.id !== "btn-domain-menu") setDomainMenu(false);
      if (e.target.id !== "btn-create-menu") setCreateMenu(false);
      if (e.target.id !== "btn-user-menu") setUserMenu(false);
    }
  };

  const getTextColor = (bgColor) => {
    const lightColor = "#fff";
    const darkColor = "#000";
    const ratio = darkMode ? 150 : 170;
    const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    const r = parseInt(color.substring(0, 2), 16); // hexToR
    const g = parseInt(color.substring(2, 4), 16); // hexToG
    const b = parseInt(color.substring(4, 6), 16); // hexToB

    return r * 0.299 + g * 0.587 + b * 0.114 > ratio ? darkColor : lightColor;
  };

  useEffect(() => {
    //registro eventi tastiera
    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.key === "s") {
        e.preventDefault();
        if (focusedTab) {
          const button = document.getElementById(`saveFileButton_${focusedTab}`);
          if (button) button.click();
        }
      }

      if (e.ctrlKey && e.key === "p") {
        e.preventDefault();
        setPathModal(!pathModal);
      }

      if (e.altKey && e.key === "n") {
        e.preventDefault();
        setCreateFileModal(true);
      }

      if (e.altKey && e.shiftKey && e.key === "n") {
        e.preventDefault();
        setCreateFolderModal(true);
      }

      if (e.key === "F5") {
        e.preventDefault();
        setShowPagePreview(!showPagePreview);
      }

      if (e.key === "Escape") {
        dismissMenus();
      }
    });

    document.addEventListener("click", dismissMenus);

    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    document.addEventListener("dragenter", () => {
      setDropFilesVisible(true);
    });

    document.addEventListener("drop", () => {
      setDropFilesVisible(false);
    });

    window.addEventListener("online", (event) => {
      setIsOnline(true);
    });

    window.addEventListener("offline", (event) => {
      setIsOnline(false);
    });

    const domains_id = `domains-${window.localStorage.getItem("companyDomain")}`;
    const languages_id = `languages-${window.localStorage.getItem("companyDomain")}`;

    if (window.localStorage.getItem(domains_id) && window.localStorage.getItem(languages_id)) {
      Domains = JSON.parse(window.localStorage.getItem(domains_id));
      Languages = JSON.parse(window.localStorage.getItem(languages_id));
      restoreTabs();
    } else {
      if (window.localStorage.getItem("companyDomain")) {
        SAFM.getDomainsJSON().then((domains) => {
          Domains = domains;
          window.localStorage.setItem(domains_id, JSON.stringify(Domains));
          SAFM.getLanguagesJSON().then((languages) => {
            Languages = languages;
            window.localStorage.setItem(languages_id, JSON.stringify(Languages));

            restoreTabs();
          });
        });
      } else {
        navigate("/login");
      }
    }
  }, []);

  const restoreCodeFromServer = (id) => {
    const list = tabs.map((item) => {
      if (item.id === id) {
        return { ...item, code: item.remoteCode, remoteCode: null };
      } else {
        return { ...item };
      }
    });

    setTabs(list);
  };

  const ignoreCodeFromServer = (id) => {
    const list = tabs.map((item) => {
      if (item.id === id) {
        return { ...item, remoteCode: null };
      } else {
        return { ...item };
      }
    });

    setTabs(list);
  };

  const restoreTabsCode = async (list) => {
    let newList = [];
    const companyDomain = window.localStorage.getItem("companyDomain");

    for (const item of list) {
      if (item.path) {
        const [code, date] = await SAFM.getFileFromServerByPath(item.path, true);
        const localDateDB = window.localStorage.getItem(`last-edit-${item.id}-${companyDomain}`);
        const localDate = !localDateDB ? 0 : parseInt(localDateDB);
        const remoteDate = new Date(date).getTime() + new Date().getTimezoneOffset() * 60 * 1000;

        console.log(remoteDate, localDate);

        if (localDate && remoteDate > localDate) {
          newList = [
            ...newList,
            {
              ...item,
              remoteTab: item.id,
              remoteCode: code,
              remoteDate: SAFM.getFormattedDate(new Date(date)),
              language: item.language ? item.language : "vb",
              screen: item.screen ? item.screen : 0,
            },
          ];
        } else {
          newList = [...newList, { ...item, language: item.language ? item.language : "vb", screen: item.screen ? item.screen : 0 }];
        }
      } else {
        newList = [...newList, { ...item, language: item.language ? item.language : "vb", screen: item.screen ? item.screen : 0 }];
      }
    }

    console.log(newList);

    return newList;
  };

  const restoreTabs = async () => {
    const companyDomain = window.localStorage.getItem("companyDomain");
    const savedTabs = window.localStorage.getItem(`tabs-${companyDomain}`);
    const savedScreens = window.localStorage.getItem(`screens-${companyDomain}`);

    browse(Domains[0].path);
    document.title = `${Domains[0].path.toLowerCase().replace("c:/pub/", "").replace("c:/", "")} | SAFM`;

    await getPubFiles();
    const listOfFiles = await getOpenFiles();
    let listOfTabs = [];
    if (savedTabs) {
      listOfTabs = JSON.parse(savedTabs);

      if (!listOfFiles.login) {
        const arrayOfFiles = listOfFiles.map(({ path }) => path);

        if (typeof listOfTabs === "string") {
          window.localStorage.clear();
          window.location.reload();
          return;
        }

        listOfTabs = listOfTabs.filter((item) => !item.path || arrayOfFiles.includes(item.path));
      }

      listOfTabs = await restoreTabsCode(listOfTabs);

      let listOfScreens = !savedScreens ? [] : JSON.parse(savedScreens);
      if (!savedScreens) {
        for (const tab of listOfTabs) {
          if (!listOfScreens.find((item) => item.id === tab.screen)) {
            listOfScreens = [
              ...listOfScreens,
              {
                id: tab.screen,
                key: tab.screen,
                activeTab: 0,
              },
            ];
          }
        }
      }

      setTabs(listOfTabs);
      setScreens(listOfScreens);

      window.localStorage.setItem(`tabs-${companyDomain}`, JSON.stringify(listOfTabs));
    }

    restored = true;

    document.getElementById("main-page").classList.remove("hidden");
    document.getElementById("status-bar").classList.remove("hidden");
    document.getElementById("loading-page").remove();
  };

  const saveFile = (tabId) => {
    const tab = tabs.find((item) => item.id === tabId);

    if (tab && tab.editable) {
      setTabs((tabs) =>
        tabs.map((item) => {
          if (item.id === tabId) {
            const { code, path } = item;
            setStatus("Salvataggio in corso...");

            const timeout = setTimeout(() => setStatus("Salvataggio del file in corso"), 1000);

            SAFM.saveFileContent(path, code).then(() => {
              setStatus("Pronto");
              clearTimeout(timeout);
            });

            const companyDomain = window.localStorage.getItem("companyDomain");
            window.localStorage.setItem(`last-edit-${tabId}-${companyDomain}`, new Date().getTime());

            return { ...item, editing: false };
          } else {
            return { ...item };
          }
        })
      );
    }
  };

  useEffect(() => {
    if (!restored) return;

    const companyDomain = window.localStorage.getItem("companyDomain");

    window.localStorage.setItem(`tabs-${companyDomain}`, JSON.stringify(tabs));
    window.localStorage.setItem(`screens-${companyDomain}`, JSON.stringify(screens));

    screens.map((screen) => {
      if (editors[screen.id] && editors[screen.id][screen.activeTab]) {
        const viewState = { ...editors[screen.id][screen.activeTab].saveViewState(), lastEdit: new Date().getTime() };
        window.localStorage.setItem(`viewState${screen.id}-${screen.activeTab}-${companyDomain}`, JSON.stringify(viewState));
      }
    });
  }, [tabs, screens]);

  const fileSystem = useRef(null);

  const showPromptModal = (title, message, result) => {
    setPromptTitle(title);
    setPromptMessage(message);
    setPromptResult(result);
    setPromptModal(true);
  };

  const selectTab = (screenId, tabId) => {
    setScreens((screens) =>
      screens.map((screen) => {
        if (screen.id === screenId) {
          return { ...screen, activeTab: tabId };
        } else {
          return { ...screen };
        }
      })
    );
  };

  const setLanguage = (language, tabId) => {
    setTabs((tabs) =>
      tabs.map((tab) => {
        if (tab.id === tabId) {
          return { ...tab, language };
        } else {
          return { ...tab };
        }
      })
    );
  };

  const dismissTab = async (tabId, fromDiscardChanges = false, fromPublishFile = false) => {
    currentFile = tabs.find((item) => item.id === tabId).path;

    const data = await SAFM.getFileHistoryByPath(currentFile);
    let original = "";
    try {
      const id = data[0].diffs[0].id;
      original = await SAFM.getFileFromServerById(id);
    } catch (err) {
      console.log(err);
    }

    const modified = await SAFM.getFileFromServerByPath(currentFile);

    //se il file originale risulta uguale alla modifica, annullo in automatico le modifiche e libero la pagina
    if (!fromPublishFile) {
      if (tabs.find((item) => item.id === tabId).editable) {
        if (!fromDiscardChanges && original.localeCompare(modified) === 0) {
          discardChanges(false);
        }
      }
    }

    let listOfScreens = [];

    const items = tabs.filter((item) => item.id !== tabId);
    items.map((item) => {
      if (!listOfScreens.find((screen) => screen.id === item.screen)) {
        const screen = screens.find((screen) => screen.id === item.screen);

        let activeTab = screen.activeTab;

        if (screen.activeTab === tabId) {
          const screenTabs = tabs.filter((tab) => tab.screen === screen.id);
          screenTabs.forEach((tab, i) => {
            if (tab.id === screen.activeTab) {
              activeTab = screenTabs[i - 1].id;
            }
          });
        }

        listOfScreens = [...listOfScreens, { ...screen, activeTab }];
      }
    });

    setScreens(listOfScreens);
    setTabs(items);
  };

  const updateCode = (text, tabId) => {
    const items = tabs.map((item) => {
      if (item.id === tabId) {
        return { ...item, code: text, editing: true };
      } else {
        return item;
      }
    });

    const companyDomain = window.localStorage.getItem("companyDomain");

    const currentTab = tabs.find((item) => item.id === tabId);
    console.log(currentTab);

    window.localStorage.setItem(`last-edit-${tabId}-${companyDomain}`, new Date().getTime());

    setTabs(items);
  };

  const cacheFiles = (path, list) => {
    const companyDomain = window.localStorage.getItem("companyDomain");
    window.localStorage.setItem(`${companyDomain}-${path.toLowerCase()}`, JSON.stringify(list));
  };

  const fetchFilesInBackground = async (path) => {
    const companyDomain = window.localStorage.getItem("companyDomain");

    let data = await SAFM.getListOfFilesByPath(path);
    if (data) {
      if ("login" in data) {
        navigate("/login");
      } else {
        window.localStorage.setItem(`${companyDomain}-${path.toLowerCase()}`, JSON.stringify(data));
      }
    }

    return data;
  };

  const browse = async (path, forceReload = false) => {
    setPathModal(false);

    setStatus("Caricamento...");

    setFileIndex(0);

    let data = {};
    const companyDomain = window.localStorage.getItem("companyDomain");

    lastPath = path.toLowerCase();

    if (!forceReload && window.localStorage.getItem(`${companyDomain}-${path.toLowerCase()}`)) {
      data = JSON.parse(window.localStorage.getItem(`${companyDomain}-${path.toLowerCase()}`));

      fetchFilesInBackground(path).then((fs) => {
        if (lastPath === path.toLowerCase()) updateFilesState(fs, path);
      });
    } else {
      data = await fetchFilesInBackground(path);
    }

    setCurrentPath(path.substr(-1, 1) === "/" ? path.substr(0, path.length - 1).toLowerCase() : path.toLowerCase());

    const nav = Domains.find((item) => item.path === path.toUpperCase()) ? [] : navigationHistory;

    setFiles(data);
    setNavigationHistory([...nav, path.toLowerCase()]);
    if (!!document.querySelector(".FileSystem")) document.querySelector(".FileSystem").scrollTo(0, 0);

    setOtp(SAFM.getUserObject().otp);
    setPhoneNumber(SAFM.getUserObject().cellulare);

    eventSourceListener(data, path);

    setSearchResults([]);

    setStatus("Pronto");

    updateFilesState(data, path);

    return true;
  };

  const updateFilesState = async (data, path) => {
    const openFiles = await SAFM.getOpenFilesByPath(path);
    try {
      data = data.map((item) => {
        const filteredItem = openFiles.find(({ name }) => name === item.path);

        return { ...item, isOpen: filteredItem ? filteredItem.author : null };
      });
      setFiles(data);
    } catch {}
  };

  const getDomainByPath = () => {
    let currentDomain = "";

    Domains.map(({ path }) => {
      if (currentPath.toUpperCase().indexOf(path) > -1) {
        currentDomain = path;
      }
    });

    return currentDomain;
  };

  const goBack = async () => {
    setStatus("Caricamento...");

    const items = navigationHistory.filter((item) => item !== currentPath);
    setNavigationHistory(items);

    let data = {};
    const path = items[items.length - 1].toLowerCase();
    const companyDomain = window.localStorage.getItem("companyDomain");

    lastPath = path.toLowerCase();

    if (window.localStorage.getItem(`${companyDomain}-${path}`)) {
      data = JSON.parse(window.localStorage.getItem(`${companyDomain}-${path}`));

      fetchFilesInBackground(path).then((fs) => {
        if (lastPath === path.toLowerCase()) updateFilesState(fs, path);
      });
    } else {
      data = await fetchFilesInBackground(path);
    }

    setCurrentPath(path.substr(-1, 1) === "/" ? path.substr(0, path.length - 1).toLowerCase() : path.toLowerCase());
    setFiles(data);

    setStatus("Pronto");

    updateFilesState(data, path);
  };

  //verifica se il file è attualmente aperto da un'altra persona oppure se è modificabile
  const checkFile = async (path) => {
    currentFile = path;

    const ext = path.split(".")[path.split(".").length - 1].toLowerCase();

    if (Languages.find((item) => item.extensions.includes(ext))) {
      setStatus("Caricamento...");
      const { editable, author } = await SAFM.checkFileStatus(path);

      setStatus("Pronto");

      if (editable) {
        openFile(path, true);
      } else {
        setCurrentAuthor(author);
        setFileBeingEditedModalVisible(true);
      }
    } else {
      if (Images.includes(ext)) {
        //preview
        setPreviewModal(true);
        setPreviewFile({
          //PREVIEW IMG
          type: "image",
          path: `${window.localStorage.getItem("companyDomain")}download.asp?path=${path}`,
        });
      } else if (ext === "pdf") {
        //PREVIEW PDF
        setPreviewModal(true);
        setPreviewFile({
          type: "pdf",
          path: `${window.localStorage.getItem("companyDomain")}download.asp?path=${path}`,
        });
      } else if (ext === "mp4") {
        //PREVIEW VIDEO
        setPreviewModal(true);
        setPreviewFile({
          type: "video",
          path: `${window.localStorage.getItem("companyDomain")}download.asp?path=${path}`,
        });
      } else {
        //DOWNLOAD
        window.open(`${window.localStorage.getItem("companyDomain")}download.asp?path=${path}`);
      }
    }
  };

  const getTabByPath = (path) => {
    return tabs.find((item) => item.path === path);
  };

  const openFile = async (path, editable) => {
    setStatus("Caricamento...");

    setOpenFilesModal(false);
    setFileBeingEditedModalVisible(false);

    if (!getTabByPath(path)) {
      setFiles((files) =>
        files.map((item) => {
          if (item.path === path) {
            return { ...item, isOpen: SAFM.getUserObject().dusr };
          } else {
            return item;
          }
        })
      );

      const code = await SAFM.getFileFromServerByPath(path);
      const id = new Date().getTime();
      const name = path.split("/")[path.split("/").length - 1].toLowerCase();
      const ext = name.split(".")[name.split(".").length - 1];

      const tab = {
        id,
        key: id,
        name,
        path,
        code,
        original: code,
        dismissable: true,
        editable,
        language: Languages.find((item) => item.extensions.includes(ext)) ? Languages.find((item) => item.extensions.includes(ext)).language : "vb",
        screen: 0,
      };

      //salvo sul db che la pagina è in modifica dall'utente
      if (editable) await SAFM.updateFileStatus(path, true);

      setTabs([...tabs, tab]);
      setScreens((screens) =>
        screens.map((screen) => {
          if (screen.id === 0) {
            return { ...screen, activeTab: tab.id };
          } else {
            return { ...screen };
          }
        })
      );

      getOpenFiles();
      getPubFiles();
    } else {
      const tab = getTabByPath(path);

      setScreens((screens) =>
        screens.map((screen) => {
          if (screen.id === tab.screen) {
            return { ...screen, activeTab: tab.id };
          } else {
            return { ...screen };
          }
        })
      );
    }

    setStatus("Pronto");
  };

  const getOpenFiles = async () => {
    const data = await SAFM.getListOfInEditingFiles();

    if (data.login) return false;

    const items = data.map((item) => ({
      ...item,
      formattedDateModified: SAFM.getFormattedDate(item.dateModified),
      relativeDateModified: SAFM.getRelativeDate(item.dateModified),
    }));

    setOpenFiles(items);
    return items;
  };

  const getPubFiles = async () => {
    const data = await SAFM.getListOfPublishedFiles();

    if (data.login) return false;

    const items = data.map((item) => ({
      ...item,
      formattedDateModified: SAFM.getFormattedDate(item.dateModified),
      relativeDateModified: SAFM.getRelativeDate(item.dateModified),
      notes: He.decode(item.notes),
    }));

    setPubFiles(items);
    return items;
  };

  const getFileHistory = async (path) => {
    setStatus("Caricamento storia modifiche...");

    try {
      const data = await SAFM.getFileHistoryByPath(path);

      if (data.login) return false;

      const items = data.map((item) => ({
        ...item,
        formattedDateModified: SAFM.getFormattedDate(item.dateModified),
        relativeDateModified: SAFM.getRelativeDate(item.dateModified),
        notes: He.decode(item.notes),
      }));

      setFileHistory(items);
      setFileHistoryModal(true);
      setStatus("Pronto");
    } catch (e) {
      setStatus("Pronto");
    }
  };

  const showEdit = async (file1, file2) => {
    setStatus("Caricamento storia modifiche...");

    const original = await SAFM.getFileFromServerById(file1.id);
    const modified = await SAFM.getFileFromServerById(file2.id);

    file1 = { ...file1, code: original };
    file2 = { ...file2, code: modified };

    setDiffs({ original: file1, modified: file2 });
    setFileDiffsModal(true);
    setStatus("Pronto");
  };

  const showPublishModal = async (tab) => {
    saveFile(tab.id);

    currentFile = tab.path;

    const data = await SAFM.getFileHistoryByPath(currentFile);

    let original = "";
    try {
      const id = data[0].diffs[0].id;
      original = await SAFM.getFileFromServerById(id);
    } catch {}

    const modified = await SAFM.getFileFromServerByPath(currentFile);
    currentCode = modified;

    setPublish(true);
    setDiffs({
      original: {
        code: original,
      },
      modified: {
        code: modified,
      },
    });
    setFileDiffsModal(true);
  };

  const publishFile = async () => {
    const notes = publishNotes;

    if (notes !== "") {
      setPublish(false);
      setStatus("Pubblicazione in corso...");

      await SAFM.publishFile(currentFile, currentCode, notes);
      setFileDiffsModal(false);

      const tab = getTabByPath(currentFile);
      if (tab) {
        dismissTab(tab.id, false, true);
        setFilePublishedModal(true);
      }

      getOpenFiles();
      getPubFiles();
      setPublishNotes("");

      setStatus("Pronto");
    } else {
      showPromptModal("Pubblicazione", "Prima di pubblicare, inserisci la descrizione delle modifiche che hai apportato alla pagina.", false);
    }
  };

  const showDiscardChangesModal = (tab) => {
    currentFile = tab.path;

    setDiscardChangesModal(true);
  };

  const discardChanges = async (dismiss = true) => {
    setStatus("Annullo le modifiche...");

    await SAFM.updateFileStatus(currentFile, false);
    setDiscardChangesModal(false);

    const tab = getTabByPath(currentFile);
    if (tab && dismiss) {
      dismissTab(tab.id, true, false);
    }

    setFiles((files) =>
      files.map((item) => {
        if (item.path === currentFile) {
          return { ...item, isOpen: null };
        } else {
          return item;
        }
      })
    );

    await getOpenFiles();
    await getPubFiles();

    setStatus("Pronto");
  };

  const search = async (q) => {
    const domain = Domains.find(({ path }) => currentPath.toUpperCase().indexOf(path) > -1);
    const data = await SAFM.getListOfFilesByTerm(domain.path, q);
    setSearchResults(data);

    if (data.length) {
      setFileIndex(0);
    }
  };

  const searchText = async () => {
    const domain = Domains.find(({ path }) => currentPath.toUpperCase().indexOf(path) > -1);
    const data = await SAFM.getListOfFilesContainsText(domain.path, text);

    setSearchTextModal(false);

    setSearchResults(data);
  };

  const triggerFileContextMenu = (e) => {
    e.preventDefault();

    const { top } = e.target.getBoundingClientRect();
    const { left } = e.target.getBoundingClientRect();

    setFileContextMenuPosition({ top, left });
    setFileContextMenu(`${currentPath}/${e.currentTarget.innerText.trim()}`);
  };

  const triggerFolderContextMenu = (e) => {
    e.preventDefault();

    const { top } = e.target.getBoundingClientRect();
    const { left } = e.target.getBoundingClientRect();

    setFolderContextMenuPosition({ top, left });
    setFolderContextMenu(e.currentTarget.innerText.trim());
  };

  const renameFile = async (oldFileName, newFileName) => {
    const cached_files = files.map((item) => {
      if (item.path === `${currentPath}/${oldFileName}`.toUpperCase()) {
        return { ...item, name: newFileName, path: `${currentPath}/${newFileName}`.toUpperCase() };
      } else {
        return item;
      }
    });
    setFiles(cached_files);
    cacheFiles(currentPath, cached_files);
    setRenameFileModal(false);

    const data = await SAFM.renameFile(currentPath, oldFileName, newFileName);
    if (!data.result) {
      showPromptModal("Errore rinominazione file", data.message, data.result);
    }
  };

  const renameFolder = async (oldFolderName, newFolderName) => {
    const cached_files = files.map((item) => {
      if (item.path === `${currentPath}/${oldFolderName}`.toUpperCase()) {
        return { ...item, name: newFolderName, path: `${currentPath}/${newFolderName}`.toUpperCase() };
      } else {
        return item;
      }
    });
    setFiles(cached_files);
    cacheFiles(currentPath, cached_files);
    setRenameFolderModal(false);

    const data = await SAFM.renameFolder(currentPath, oldFolderName, newFolderName);
    if (!data.result) {
      showPromptModal("Errore rinominazione cartella", data.message, data.result);
    }
  };

  const removeFile = async () => {
    const cached_files = files.filter((item) => item.path !== `${currentPath}/${removeFilePath}`.toUpperCase());
    setFiles(cached_files);
    cacheFiles(currentPath, cached_files);
    setRemoveFileModal(false);

    const data = await SAFM.removeFile(currentPath, removeFilePath);
    if (!data.result) {
      showPromptModal("Errore eliminazione file", data.message, data.result);
    }
  };

  const removeFolder = async () => {
    const cached_files = files.filter((item) => item.path !== `${currentPath}/${removeFolderPath}`.toUpperCase());
    setFiles(cached_files);
    cacheFiles(currentPath, cached_files);
    setRemoveFolderModal(false);

    const data = await SAFM.removeFolder(currentPath, removeFolderPath);
    if (!data.result) {
      showPromptModal("Errore eliminazione cartella", data.message, data.result);
    }
  };

  const getItalianDate = (date) => {
    const dd = date.getDate().toString();
    const mm = (date.getMonth() + 1).toString();
    const yy = date.getFullYear().toString();
    const hh = date.getHours().toString();
    const mn = date.getMinutes().toString();

    return `${dd.padStart(2, 0)}/${mm.padStart(2, 0)}/${yy} ${hh.padStart(2, 0)}:${mn.padStart(2, 0)}:00`;
  };

  const create = async (type) => {
    const name = type === "file" ? createFileName : createFolderName;
    const data = await SAFM.createNew(currentPath, name, type);

    if (data.result) {
      if (type === "file") {
        setCreateFileModal(false);
        setCreateFileName("");
        checkFile(`${currentPath}/${name}`.toUpperCase());
      } else if (type === "folder") {
        setCreateFolderModal(false);
        setCreateFolderName("");
      }

      let cached_files = [
        ...files,
        {
          type,
          name: name,
          path: `${currentPath}/${name}`.toUpperCase(),
          download: false,
          size: "0 Bytes",
          isOpen: null,
          dateCreated: getItalianDate(new Date()),
          dateLastModified: getItalianDate(new Date()),
        },
      ];

      cached_files = [
        ...cached_files.filter((item) => item.type === "folder"),
        ...cached_files.filter((item) => item.type === "file").sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)),
      ];

      cacheFiles(currentPath, cached_files);
      setFiles(cached_files);
    }
  };

  const uploadFile = async (e) => {
    setUploading(true);
    setFileUploadModal(true);

    const uploadService = SAFM.getService("upload");

    const formData = new FormData();
    formData.append("blob", e.target.files[0]);

    const request = new XMLHttpRequest();
    request.onload = (e) => {
      if (request.status === 200) {
        setFileUploadModal(false);
        setUploading(false);
        setUploadPercentage(0);

        e.target.value = ""; //reset

        browse(currentPath, true);
      } else {
        console.log("error");
      }
    };
    request.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        let percentComplete = e.loaded / e.total;
        percentComplete = parseInt(percentComplete * 100);
        setUploadPercentage(percentComplete);
      }
    };
    request.open("POST", `${uploadService}&path=${currentPath}`, true);
    request.send(formData);
  };

  const showTables = async () => {
    setTablesModal(true);
    const tables = await SAFM.getSQLTables();

    setListOfTables(tables);
    setFilteredListOfTables(tables);
  };

  const filterTables = (q) => {
    const tables = listOfTables.data;
    setFilteredListOfTables({
      data: tables.filter((item) => item[0].toLowerCase().indexOf(q.toLowerCase()) > -1 || item[1].toLowerCase().indexOf(q.toLowerCase()) > -1),
    });
  };

  const showTableStructure = async (table) => {
    setListOfFields({ columns: [], data: [[]] });

    setFieldsModal(true);
    const fields = await SAFM.getSQLFields(table);
    setSelectedTable(table);

    setListOfFields(fields);
  };

  const showTop1000 = async (table) => {
    setListOfTop1000({ columns: [], data: [[]] });

    setTop1000Modal(true);
    const top1000 = await SAFM.getSQLTop1000(table);
    setSelectedTable(table);

    setListOfTop1000(top1000);
  };

  const changePassword = async () => {
    setStatus("Cambio password in corso...");
    const { message, result } = await SAFM.changePassword(currentPassword, newPassword, repeatPassword);

    if (result) {
      setCurrentPassword("");
      setNewPassword("");
      setRepeatPassword("");

      setPasswordModal(false);
    }

    showPromptModal("Cambio password", message, result);

    setStatus("Pronto");
  };

  const saveSettings = async () => {
    setStatus("Salvo impostazioni...");

    const { message, result } = await SAFM.changeSettings(otp, phoneNumber);

    if (result) {
      setSettingsModal(false);
    }

    showPromptModal("Salvataggio impostazioni", message, result);

    setStatus("Pronto");
  };

  const isSupported = (file) => {
    const ext = file.split(".")[file.split(".").length - 1].toLowerCase();
    return !!Languages.find((item) => item.extensions.includes(ext));
  };

  const logout = () => {
    restored = false;
    setUserMenu(false);
    navigate("/login");
  };

  const getTabIndexById = (id) => {
    for (let i = 0; i < tabs.length; i++) {
      if (tabs[i].id === id) return i;
    }
  };

  const onDropSplitter = (e, screen) => {
    const item = document.elementFromPoint(e.pageX, e.pageY);

    if (draggingTab && draggingTab.id > 0 && (draggingTab.screen !== parseInt(item.dataset.screen) || screens.length === 1)) {
      const direction = item.dataset.split;

      let listOfTabs = [];
      if (direction === "left") {
        listOfTabs = tabs.map((tab) => {
          if (tab.screen === screen.id && tab.id > 0 && tab.id !== screen.activeTab) {
            return { ...tab, screen: tab.screen + 1 };
          } else {
            return { ...tab };
          }
        });
      } else if (direction === "right") {
        listOfTabs = tabs.map((tab) => {
          if (tab.id === screen.activeTab) {
            return { ...tab, screen: tab.screen + 1 };
          } else {
            return { ...tab };
          }
        });
      } else if (direction === "center") {
        listOfTabs = tabs.map((tab) => {
          if (tab.id === draggingTab.id) {
            return { ...tab, screen: parseInt(item.dataset.screen) };
          } else {
            return { ...tab };
          }
        });
      }

      let listOfScreens = [];
      for (const tab of listOfTabs) {
        if (!listOfScreens.find((item) => item.id === tab.screen)) {
          let activeTab = draggingTab.id;

          console.log(direction);

          if (direction === "left") {
            activeTab = tab.screen === screen.id ? screen.activeTab : tab.id;
          } else if (direction === "right") {
            let index = 0;
            const items = tabs.filter((item) => item.id !== screen.activeTab);
            tabs.filter((tab) => tab.screen === screen.id).forEach((t, i) => (index = t.id === screen.activeTab ? i : index));

            activeTab = tab.screen === screen.id + 1 ? screen.activeTab : items[index - 1].id;
          } else if (direction === "center") {
            console.log(screen.id, tab.screen);

            if (screen.id !== tab.screen) {
              activeTab = listOfTabs.find((item) => item.screen === tab.screen).id;
            }
          }

          listOfScreens = [
            ...listOfScreens,
            {
              id: tab.screen,
              key: tab.screen,
              activeTab,
            },
          ];
        }
      }

      setTabs(listOfTabs);
      setScreens(listOfScreens);
    }

    const screenSplitters = document.querySelectorAll('[data-role="screen-splitter"]');
    for (const screenSplitter of screenSplitters) screenSplitter.style.display = "none";

    setDropFilesVisible(false);
    draggingTab = null;
  };

  return (
    <div className='flex flex-col overflow-hidden h-screen dark:bg-black'>
      <div id='loading-page' className='flex items-center justify-center overflow-hidden h-screen'>
        <Spinner color='blue'></Spinner>
      </div>
      <div id='main-page' className='hidden flex overflow-hidden h-screen'>
        {screens.map((screen, i) => (
          <>
            <div data-role='screen' id={`screen_${screen.id}`} key={screen.key} className='relative flex flex-col overflow-hidden w-full h-screen'>
              <div className=' flex bg-black-050 dark:bg-black-900 overflow-x-auto overflow-y-hidden h-8' style={{ WebkitAppRegion: "drag" }}>
                {tabs
                  .filter((item) => item.screen === screen.id)
                  .map((tab) => (
                    <Tab
                      key={tab.id}
                      screen={screen.id}
                      active={screen.activeTab === tab.id}
                      {...tab}
                      onClick={() => selectTab(screen.id, tab.id)}
                      onDismiss={(e) => {
                        e.stopPropagation();
                        dismissTab(tab.id, false, false);
                      }}
                      onDragStart={(e) => {
                        draggingTab = tab;
                      }}
                      onDrop={(e) => {
                        if (tab.id > 0) {
                          const draggingTabIndex = getTabIndexById(draggingTab.id);
                          const currentTabIndex = getTabIndexById(tab.id);

                          let listOfTabs = tabs;
                          let temporaryTab = listOfTabs[draggingTabIndex];
                          listOfTabs[draggingTabIndex] = tabs[currentTabIndex];
                          listOfTabs[currentTabIndex] = temporaryTab;

                          setTabs(listOfTabs);
                        }
                      }}
                    />
                  ))}
              </div>

              <div
                onDragEnter={() => {
                  //SCREENS
                  const screenSplitter = document.querySelector(`#screenSplitter_${screen.id}`);
                  screenSplitter.style.display = "flex";
                }}
                className={screen.activeTab > 0 ? "relative block" : "hidden"}>
                <div className='flex bg-white dark:bg-black py-2 select-none'>
                  <div className='flex flex-1 items-center'>
                    {tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).editable && (
                      <ToolbarButton id={`saveFileButton_${screen.activeTab}`} onClick={() => saveFile(screen.activeTab)} title='Salva (CTRL+S)'>
                        <FiSave className='select-none' />
                      </ToolbarButton>
                    )}
                    <ToolbarButton
                      onClick={() => getFileHistory(tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).path)}
                      title='Vedi storia modifiche'>
                      <FiClock className='select-none' />
                    </ToolbarButton>
                    <ToolbarButton onClick={() => setShowPagePreview(!showPagePreview)} title='Mostra anteprima pagina (F5)'>
                      <FiPlay className='select-none' />
                    </ToolbarButton>
                    <select
                      className='h-8 bg-black-050 dark:bg-black-950 rounded-lg text-sm text-black dark:text-white px-2 mx-2'
                      value={tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).language}
                      onChange={({ target }) => setLanguage(target.value, screen.activeTab)}>
                      <option value='vb'>ASP</option>
                      <option value='css'>CSS</option>
                      <option value='html'>HTML</option>
                      <option value='javascript'>javascript</option>
                      <option value='json'>JSON</option>
                    </select>
                    <span className='text-black-300 dark:text-black-700 text-sm mx-2 text-center pl-1.5'>|</span>
                    {tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).editable && (
                      <>
                        <ToolbarButton title='Annulla (CTRL+Z)' onClick={() => editors[screen.id][screen.activeTab].trigger("", "undo")}>
                          <FiRotateCcw />
                        </ToolbarButton>
                        <ToolbarButton
                          onClick={() => {
                            editors[screen.id][screen.activeTab].trigger("", "redo");
                          }}
                          title='Ripristina (CTRL+Y)'>
                          <FiRotateCw />
                        </ToolbarButton>
                      </>
                    )}
                    <ToolbarButton
                      onClick={() => {
                        editors[screen.id][screen.activeTab].trigger("", "actions.find");
                      }}
                      title='Cerca... (CTRL+F)'>
                      <FiSearch />
                    </ToolbarButton>
                    <ToolbarButton
                      onClick={() => {
                        editors[screen.id][screen.activeTab].focus();
                        editors[screen.id][screen.activeTab].trigger("", "editor.action.gotoLine");
                      }}
                      title='Vai alla riga (CTRL+G)'>
                      <FiAlignLeft />
                    </ToolbarButton>
                    {tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).editable && (
                      <ToolbarButton
                        onClick={() => {
                          editors[screen.id][screen.activeTab].trigger("", "editor.action.addCommentLine");
                        }}
                        title='Commenta codice selezionato (CTRL+ù)'>
                        <FiMessageSquare />
                      </ToolbarButton>
                    )}
                  </div>
                  {tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).editable && (
                    <div className='flex mx-2 gap-4'>
                      <button
                        className='h-8 bg-blue px-2 text-sm rounded-lg text-white hover:opacity-70 transition-all'
                        onClick={() => showPublishModal(tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab))}>
                        Pubblica modifiche
                      </button>
                      <button
                        className='h-8 px-2 text-sm rounded-lg text-black-700 dark:text-black-400 hover:opacity-70 transition-all'
                        onClick={() => showDiscardChangesModal(tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab))}>
                        Annulla modifiche
                      </button>
                    </div>
                  )}
                </div>

                {screens.length === 1 && (
                  <div
                    data-role='screen-splitter'
                    style={{ display: "none" }}
                    id={`screenSplitter_${screen.id}`}
                    className='absolute top-0 left-0 flex w-full h-full z-[9999] cursor-move'>
                    <Splitter dataSplit='left' onDrop={(e) => onDropSplitter(e, screen)} />
                    <Splitter dataSplit='right' onDrop={(e) => onDropSplitter(e, screen)} />
                  </div>
                )}

                <div className='relative flex'>
                  {/* <div className='bg-white p-4'>...</div> */}

                  <>
                    {!!tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).remoteCode && (
                      <div className='absolute flex items-center gap-2 top-1 translate-x-[-50%] left-[50%] flex p-3 bg-black-900 text-white rounded-md z-[1]'>
                        <span className='text-base'>
                          Sul server è presente una versione più recente del file (
                          {tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).remoteDate}).
                        </span>
                        <button onClick={() => restoreCodeFromServer(screen.activeTab)} className='h-10 px-2 rounded-md bg-amber text-[#000]'>
                          Ripristina
                        </button>
                        <button onClick={() => ignoreCodeFromServer(screen.activeTab)} className='h-10 px-2 rounded-md border border-black-500'>
                          Ignora
                        </button>
                      </div>
                    )}
                    {tabs.map((tab) => {
                      return (
                        tab.id > 0 && (
                          <Editor
                            key={tab.id}
                            width={screen.activeTab === tab.id ? "100%" : 0}
                            height={screen.activeTab === tab.id ? "calc(100vh - 104px)" : 0}
                            defaultLanguage={tab.language}
                            language={tab.language}
                            theme={darkMode ? "vs-dark" : "vs-light"}
                            defaultValue={tab.code}
                            value={tab.code}
                            options={{
                              selectOnLineNumbers: true,
                              readOnly: !tab.editable,
                              suggest: true,
                              fontSize: 13,
                            }}
                            onChange={(text) => updateCode(text, tab.id)}
                            saveViewState={false}
                            keepCurrentModel={false}
                            onMount={(e, m) => handleEditorDidMount(e, m, screen.id, tab.id)}
                          />
                        )
                      );
                    })}
                  </>
                </div>

                {screen.activeTab > 0 && showPagePreview && (
                  <div className='absolute left-0 bottom-0 w-full h-[44vh] p-0.5 flex flex-col bg-black-050 dark:bg-black-900 '>
                    <div>
                      <div className='flex items-center'>
                        <h1 className='px-2 text-base dark:text-white flex-1'>
                          Anteprima <span className='text-xs mx-2 opacity-70'>{elementPath}</span>
                        </h1>
                        <button className='w-8 h-8 flex items-center justify-center text-black dark:text-white' onClick={() => setShowPagePreview(false)}>
                          <FiX />
                        </button>
                      </div>
                    </div>
                    <iframe
                      className='flex-1 bg-white border-none dark:bg-black'
                      onLoad={(e) =>
                        PagePreview.init(
                          e,
                          editors[screen.id][screen.activeTab],
                          tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).code,
                          setElementPath
                        )
                      }
                      srcDoc={PagePreview.cleanCode(tabs.find((item) => item.screen === screen.id && item.id === screen.activeTab).code)}></iframe>
                  </div>
                )}
              </div>

              <div
                onDragEnter={() => {
                  //SCREENS
                  const screenSplitter = document.querySelector(`#screenSplitter_${screen.id}`);
                  screenSplitter.style.display = "flex";
                }}
                className={screen.activeTab === 0 ? "flex flex-col flex-1 overflow-hidden" : "hidden"}>
                <div className='flex bg-white dark:bg-black py-2 select-none'>
                  <div className='flex flex-1 items-center'>
                    <h4
                      className='flex items-center mx-2 text-xl text-black dark:text-white font-semibold px-1 cursor-pointer select-none'
                      id='btn-domain-menu'
                      onClick={() => setDomainMenu(!domainMenu)}>
                      {currentPath.replace("c:/pub/", "").replace("c:/", "")}
                      <FiChevronDown className='ml-1 pointer-events-none' />
                    </h4>

                    {domainMenu && (
                      <ContextMenu top={56} left={1}>
                        {Domains.map(({ path, name }) => {
                          return (
                            <ContextMenuItem
                              key={path}
                              onClick={() => {
                                browse(path);
                                setDomainMenu(false);
                                document.title = `${path.toLowerCase().replace("c:/pub/", "").replace("c:/", "")} | SAFM`;
                              }}
                              title={path.replace("C:/PUB/", "").replace("C:/", "").toLowerCase()}>
                              {name}
                            </ContextMenuItem>
                          );
                        })}
                      </ContextMenu>
                    )}

                    <div className='relative'>
                      <ToolbarButton id='btn-create-menu' onClick={() => setCreateMenu(!createMenu)}>
                        <FiPlus className='pointer-events-none' />
                      </ToolbarButton>
                      {createMenu && (
                        <ContextMenu position='absolute' top={16} left={-1}>
                          <ContextMenuItem
                            title='Crea nuovo file (ALT + N)'
                            onClick={() => {
                              setCreateMenu(false);
                              setCreateFileModal(true);
                            }}>
                            Nuovo file
                          </ContextMenuItem>
                          <ContextMenuItem
                            title='Crea nuova cartella'
                            onClick={() => {
                              setCreateMenu(false);
                              setCreateFolderModal(true);
                            }}>
                            Nuova cartella
                          </ContextMenuItem>
                        </ContextMenu>
                      )}
                    </div>

                    <ToolbarButton onClick={() => setFileUploadModal(true)}>
                      <FiUpload className='pointer-events-none' />
                    </ToolbarButton>
                    <ToolbarButton onClick={() => setOpenFilesModal(true)} title={openFiles.length > 0 ? `${openFiles.length} pagine aperte` : null}>
                      <FiFolder className='pointer-events-none' />
                      {openFiles.length > 0 && <small className='absolute w-2 h-2 bg-red rounded-full bottom-1.5 right-1.5'></small>}
                    </ToolbarButton>
                    <ToolbarButton onClick={showTables}>
                      <FiDatabase className='pointer-events-none' />
                    </ToolbarButton>
                    {text && (
                      <ToolbarButton
                        onClick={() => {
                          setSearchResults([]);
                          setText("");
                        }}
                        title='Annulla ricerca testo'>
                        <FiX className='pointer-events-none' />
                      </ToolbarButton>
                    )}
                    {!text && (
                      <ToolbarButton title='Ricerca testo nelle pagine' onClick={() => setSearchTextModal(true)}>
                        <FiSearch className='pointer-events-none' />
                      </ToolbarButton>
                    )}
                  </div>
                  <div className='relative flex mx-3'>
                    {SAFM.getUserObject().dusr && (
                      <div
                        title={SAFM.getUserObject().dusr}
                        id='btn-user-menu'
                        className='flex items-center text-blue cursor-pointer'
                        onClick={() => setUserMenu(!userMenu)}>
                        <div
                          className='w-8 h-8 flex items-center justify-center rounded-full pointer-events-none'
                          style={{ background: SAFM.generateColor(SAFM.getUserObject().dusr) }}>
                          <span className='text-sm text-white font-semibold'>{SAFM.getUserObject().dusr.substr(0, 1)}</span>
                        </div>
                      </div>
                    )}
                    {userMenu && (
                      <ContextMenu position='absolute' top={16} right={1}>
                        <ContextMenuItem title='Modifica le tue impostazioni' onClick={() => setSettingsModal(true)}>
                          Impostazioni utente
                        </ContextMenuItem>
                        <ContextMenuItem title='Esegui disconnessione (logout)' onClick={logout}>
                          Logout
                        </ContextMenuItem>
                      </ContextMenu>
                    )}
                  </div>
                </div>
                <div className='flex bg-white dark:bg-black p-3 pt-0 select-none'>
                  {navigationHistory.length > 1 && (
                    <button
                      className='relative flex items-center justify-center text-blue h-8 w-8 mr-2 rounded-lg cursor-pointer hover:bg-blue-200 transition-all'
                      onClick={goBack}>
                      <FiArrowLeft />
                    </button>
                  )}
                  <div className='flex flex-1 items-center'>
                    <input
                      className='w-full h-8 bg-black-050 rounded-lg px-2 text-sm text-black dark:bg-black-900 dark:text-white focus:outline-none'
                      onChange={({ target }) => search(target.value)}
                      placeholder='Cerca pagina...'
                      type='search'
                    />
                  </div>
                </div>
                <div
                  className={searchResults.length === 0 ? "flex-1 h-full bg-white dark:bg-black overflow-y-auto select-none pb-16" : "hidden"}
                  ref={fileSystem}>
                  <div className={dropFilesVisible ? "fixed top-0 left-0 w-full h-screen" : "hidden"}>
                    <input className='w-full h-screen opacity-0' onChange={uploadFile} type='file'></input>
                  </div>
                  <table className='text-black dark:text-white dark:bg-black w-full'>
                    <thead>
                      <tr className='h-8'>
                        <th className='text-sm text-left border-r border-b border-black-200 dark:border-black-800 px-3' width={"40%"}>
                          Nome
                        </th>
                        <th className='text-sm text-left border-r border-b border-black-200 dark:border-black-800 px-3' width={"10%"}>
                          Dimensioni
                        </th>
                        <th className='text-sm text-left border-r border-b border-black-200 dark:border-black-800 px-3' width={"15%"}>
                          Data creazione
                        </th>
                        <th className='text-sm text-left border-r border-b border-black-200 dark:border-black-800 px-3' width={"15%"}>
                          Data ultima modifica
                        </th>
                        <th className='text-sm text-left border-b border-black-200 dark:border-black-800 px-3'>Stato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {files.slice(0, 50 * (fileIndex + 1)).map(({ name, type, path, download, size, dateCreated, dateLastModified, isOpen }, i) => {
                        let color = darkMode ? "#f7f7f7" : "#333";
                        let ext = "";
                        try {
                          ext = name.split(".")[name.split(".").length - 1].toLowerCase();
                          color = Languages.find((item) => item.extensions.includes(ext)).color;
                        } catch {}

                        return (
                          <tr key={path} className={`${i % 2 ? "bg-black-050 dark:bg-black-950" : "bg-white dark:bg-black"} hover:bg-blue-200 transition-all`}>
                            <td className='text-sm h-8 px-3'>
                              <a
                                className='flex items-center hover:text-blue cursor-pointer'
                                onContextMenu={(e) => (type === "folder" ? triggerFolderContextMenu(e) : triggerFileContextMenu(e))}
                                onClick={type === "folder" ? () => browse(path) : () => checkFile(path)}>
                                {type === "folder" ? <FiFolder style={{ fill: "gold" }} color={"gold"} /> : <FileIcon ext={ext} color={color} />}&nbsp;&nbsp;
                                {name}
                                {isOpen && (
                                  <span
                                    className='ml-3 py-1 px-2 rounded-full text-white text-xs font-medium inline-flex items-center justify-center min-w-[20px]'
                                    style={{ backgroundColor: SAFM.generateColor(isOpen), color: getTextColor(SAFM.generateColor(isOpen)) }}
                                    title={`Pagina aperta in modifica da ${isOpen}`}>
                                    {isOpen}
                                  </span>
                                )}
                              </a>
                            </td>
                            <td className='text-sm h-8 px-3'>{size}</td>
                            <td className='text-sm h-8 px-3 whitespace-nowrap'>{dateCreated}</td>
                            <td className='text-sm h-8 px-3 whitespace-nowrap'>{dateLastModified}</td>
                            <td className='text-sm h-8 px-3'>
                              {type !== "folder" && isSupported(path) ? (
                                <span
                                  className='bg-blue py-1 px-2 rounded-full text-white text-xs font-medium inline-flex items-center justify-center min-w-[20px] cursor-pointer hover:opacity-60 transition-all'
                                  onClick={() => getFileHistory(path)}>
                                  <FiClock className='mr-1' /> Storia modifiche
                                </span>
                              ) : null}
                            </td>
                          </tr>
                        );
                      })}
                      <tr ref={addFileItemRef}></tr>
                    </tbody>
                  </table>
                </div>
                {searchResults.length > 0 && (
                  <div className='bg-white dark:bg-black overflow-auto pb-40'>
                    {searchResults.map((item) => {
                      return (
                        <div className='mb-4 mx-3 py-3 px-2 rounded-lg bg-black-050 dark:bg-black-950 select-none' key={item.id}>
                          <h4 className='flex items-center cursor-pointer mb-2'>
                            <span
                              className='flex items-center text-base text-black dark:text-white font-semibold hover:text-blue transition-all'
                              title='Apri pagina in modifica'
                              onClick={() => checkFile(item.path, item.type)}>
                              <FiFileText className='mr-1' /> {item.path.toLowerCase()}
                            </span>
                            <a
                              title='Apri in sola lettura'
                              className='flex items-center justify-center w-8 h-8 bg-blue-200 text-blue rounded-lg ml-4 mr-2 hover:bg-blue hover:text-white transition-all'
                              onClick={() => openFile(item.path, false)}>
                              <FiEye />
                            </a>
                            <a
                              title='Vedi storia modifiche'
                              className='flex items-center justify-center w-8 h-8 bg-blue-200 text-blue rounded-lg hover:bg-blue hover:text-white transition-all'
                              onClick={() => getFileHistory(item.path)}>
                              <FiClock />
                            </a>
                          </h4>
                          <span className='inline-flex items-center border border-black-200 dark:border-black-800 p-1 rounded-full text-sm bg-white dark:bg-black dark:text-white'>
                            {item.status === "P" ? <FiGlobe className='mx-1' /> : <FiEdit className='mx-1' />}
                            {item.status === "P" ? "Pubblicato da " : "In modifica da "}
                            <div
                              className='py-1 px-2 rounded-full text-xs font-medium inline-flex items-center justify-center'
                              style={{ marginLeft: 6, backgroundColor: SAFM.generateColor(item.author), color: getTextColor(SAFM.generateColor(item.author)) }}>
                              {item.author}
                            </div>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {screens.length > 1 && (
                <div
                  data-role='screen-splitter'
                  style={{ display: "none" }}
                  id={`screenSplitter_${screen.id}`}
                  className='absolute top-0 left-0 flex w-full h-full z-[9999] cursor-move'>
                  <Splitter dataSplit='center' dataScreen={screen.id} onDrop={(e) => onDropSplitter(e, screen)} />
                </div>
              )}
            </div>
            {screens.length > 1 && i < screens.length - 1 && (
              <div
                onMouseDown={(e) => {
                  resizing = true;

                  const elem = e.currentTarget;

                  elem.dataset.x = e.clientX;
                  elem.dataset.diff = elem.dataset.diff ? elem.dataset.diff : 0;
                  elem.dataset.width = elem.dataset.width ? elem.dataset.width : 100;

                  elem.innerHTML += '<div data-role="backdrop" class="fixed z-[9999] top-0 left-0 w-full h-screen"></div>';
                }}
                onMouseMove={(e) => {
                  if (resizing) {
                    const item = document.getElementById(`screen_${screen.id}`);
                    const delta = parseFloat(e.currentTarget.dataset.x - e.clientX);
                    const initWidth = parseInt(e.currentTarget.dataset.width);
                    const perc = (delta / (window.innerWidth / screens.length)) * 100;

                    item.style.width = `${initWidth - perc}%`;
                  }
                }}
                onMouseUp={(e) => {
                  resizing = false;

                  const item = document.getElementById(`screen_${screen.id}`);
                  e.currentTarget.dataset.width = item.style.width.replace("%", "");

                  document.querySelector("[data-role='backdrop']").remove();
                }}
                className='relative h-screen w-1 cursor-col-resize'>
                <div className='relative w-full h-full bg-black-200 dark:bg-black-800 pointer-events-none'></div>
              </div>
            )}
          </>
        ))}
      </div>

      {fileBeingEditedModal && (
        <Modal title='Pagina aperta in modifica' onDismiss={() => setFileBeingEditedModalVisible(false)}>
          <ModalBody>
            La pagina che stai aprendo è attualmente aperta da <b>{currentAuthor}</b>.<br />
            Vuoi aprirla in sola lettura oppure sovrascriverne i cambiamenti?
          </ModalBody>
          <ModalFooter>
            <ModalButton type='primary' text='Apri in sola lettura' onClick={() => openFile(currentFile, false)} />
            <ModalButton type='danger' text='Sovrascrivi cambiamenti' onClick={() => openFile(currentFile, true)} />
            <ModalButton text='Annulla' onClick={() => setFileBeingEditedModalVisible(false)} />
          </ModalFooter>
        </Modal>
      )}

      {renameFileModal && (
        <Modal title='Rinomina file' onDismiss={() => setRenameFileModal(false)}>
          <ModalBody>
            <ModalInput autoFocus type='text' onChange={({ target }) => setNewFileName(target.value)} value={newFileName} placeholder='Rinomina file' />
          </ModalBody>
          <ModalFooter>
            <ModalButton type='primary' text='Rinomina file' onClick={() => renameFile(oldFileName, newFileName)} />
            <ModalButton text='Annulla' onClick={() => setRenameFileModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {renameFolderModal && (
        <Modal title='Rinomina cartella' onDismiss={() => setRenameFolderModal(false)}>
          <ModalBody>
            <ModalInput autoFocus type='text' onChange={({ target }) => setNewFolderName(target.value)} value={newFolderName} placeholder='Rinomina cartella' />
          </ModalBody>
          <ModalFooter>
            <ModalButton type='primary' text='Rinomina file' onClick={() => renameFolder(oldFolderName, newFolderName)} />
            <ModalButton text='Annulla' onClick={() => setRenameFolderModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {removeFileModal && (
        <Modal title='Elimina file' onDismiss={() => setRemoveFileModal(false)}>
          <ModalBody>
            Vuoi veramente eliminare il file <b>"{removeFilePath}"</b>?
          </ModalBody>
          <ModalFooter>
            <ModalButton type='danger' text='Elimina' onClick={removeFile} />
            <ModalButton text='Annulla' onClick={() => setRemoveFileModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {removeFolderModal && (
        <Modal title='Elimina cartella' onPress={() => setRemoveFolderModal(false)}>
          <ModalBody>
            Vuoi veramente eliminare la cartella <b>"{removeFolderPath}"</b>?
          </ModalBody>
          <ModalFooter>
            <ModalButton type='danger' text='Elimina' onClick={removeFolder} />
            <ModalButton text='Annulla' onClick={() => setRemoveFolderModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {createFileModal && (
        <Modal title='Crea nuovo file' onDismiss={() => setCreateFileModal(false)}>
          <ModalBody>
            <ModalInput
              autoFocus
              type='text'
              onChange={({ target }) => setCreateFileName(target.value)}
              value={createFileName}
              placeholder='Inserisci il nome del file (es. file.asp)'
            />
          </ModalBody>
          <ModalFooter>
            <ModalButton type='primary' text='Crea file' onClick={() => create("file")} />
            <ModalButton text='Annulla' onClick={() => setCreateFileModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {createFolderModal && (
        <Modal title='Crea nuova cartella' onDismiss={() => setCreateFolderModal(false)}>
          <ModalBody>
            <ModalInput
              autoFocus
              type='text'
              onChange={({ target }) => setCreateFolderName(target.value)}
              value={createFolderName}
              placeholder='Inserisci il nome della cartella'
            />
          </ModalBody>
          <ModalFooter>
            <ModalButton type='primary' text='Crea cartella' onClick={() => create("folder")} />
            <ModalButton text='Annulla' onClick={() => setCreateFolderModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {openFilesModal && (
        <Modal type='xl' onDismiss={() => setOpenFilesModal(false)}>
          <ModalHeader icon={<FiFolder />} title='Elenco pagine'>
            <div className='flex mt-2 gap-2'>
              <a
                className={`cursor-pointer py-1 px-3 rounded-full text-black text-sm font-medium inline-flex items-center justify-center ${
                  pageList === "open" ? "bg-blue text-white" : "bg-black-050 dark:bg-black-950 dark:text-white"
                } hover:opacity-60 transition-all`}
                onClick={() => setPageList("open")}>
                Aperte
              </a>
              <a
                className={`cursor-pointer py-1 px-3 rounded-full text-black text-sm font-medium inline-flex items-center justify-center ${
                  pageList === "pub" ? "bg-blue text-white" : "bg-black-050 dark:bg-black-950 dark:text-white"
                } hover:opacity-60 transition-all`}
                onClick={() => setPageList("pub")}>
                Pubblicate
              </a>
            </div>
          </ModalHeader>

          <ModalBody>
            {pageList === "open" &&
              openFiles.map((file) => {
                return (
                  <div key={file.path} className='flex items-center rounded-lg mb-3 p-3 bg-black-050 dark:bg-black-950 select-none'>
                    <div className='flex-1 cursor-pointer' onClick={() => checkFile(file.path, file.type)}>
                      <h4 className='mb-1 text-base text-blue font-medium'>{file.path.toLowerCase()}</h4>
                      <span className='text-black-700 text-xs dark:text-black-400'>
                        Aperto {file.relativeDateModified} - {file.formattedDateModified}
                      </span>
                    </div>
                    <div className='flex gap-2'>
                      <button className='h-10 bg-blue text-white rounded-lg px-2' onClick={() => showPublishModal({ path: file.path })}>
                        Pubblica
                      </button>
                      <button className='h-10 text-black-700 rounded-lg px-2 dark:text-black-400' onClick={() => showDiscardChangesModal({ path: file.path })}>
                        Annulla modifiche
                      </button>
                    </div>
                  </div>
                );
              })}
            {pageList === "pub" &&
              pubFiles.map((file) => {
                return (
                  <div key={file.id} className='flex items-center rounded-lg mb-3 p-3 bg-black-050 dark:bg-black-950 select-none'>
                    <div className='flex-1 cursor-pointer' onClick={() => checkFile(file.path, file.type)}>
                      <h4 className='mb-1 text-base text-blue font-medium'>{file.path.toLowerCase()}</h4>
                      <span className='text-black-700 text-xs dark:text-black-400'>
                        {file.relativeDateModified} - {file.formattedDateModified}
                      </span>
                      <span className='text-sm text-black dark:text-white block mt-2'>{file.notes}</span>
                    </div>
                  </div>
                );
              })}
          </ModalBody>

          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setOpenFilesModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {fileHistoryModal && (
        <Modal
          type='xl'
          onDismiss={() => {
            setFileHistoryModal(false);
          }}>
          <ModalHeader icon={<FiClock />} title='Storia delle modifiche' />
          <div className='p-3 text-white max-h-[calc(100vh-330px)] overflow-auto'>
            {fileHistory.map((file) => {
              return (
                <div key={file.id}>
                  <div className='flex items-center mb-3'>
                    <div
                      className='text-white h-9 w-9 rounded-full flex items-center justify-center text-lg select-none'
                      style={{ background: SAFM.generateColor(file.author) }}>
                      <span>{file.author.substr(0, 1)}</span>
                    </div>
                    <div className='p-2 flex flex-col flex-1 border-b border-black-200 dark:border-black-800'>
                      <div className='flex items-center'>
                        <h4 className='text-base text-blue'>{file.author}</h4>&nbsp;&nbsp;
                        <span title={file.formattedDateModified} className='text-xs text-black-700 dark:text-black-400'>
                          pubblicato {file.relativeDateModified}
                        </span>
                        &nbsp;&nbsp;
                        <button
                          type='button'
                          className='h-8 text-sm bg-blue text-white rounded-lg px-2 leading-[0px] hover:opacity-60 transition-all'
                          onClick={() => showEdit(file.diffs[1], file.diffs[0])}>
                          Vedi modifiche
                        </button>
                      </div>
                      <div className='my-2 text-sm text-black dark:text-white'>{file.notes}</div>
                    </div>
                  </div>
                </div>
              );
            })}
            {fileHistory.length === 0 && (
              <div className='text-sm text-black py-3 dark:text-white'>Nessuna storia delle modifiche presente per questa pagina.</div>
            )}
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setFileHistoryModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {fileDiffsModal && (
        <Modal onDismiss={() => setFileDiffsModal(false)} type='xl' backdropStyle={{ backgroundColor: `rgba(0, 0, 0, ${fileHistoryModal ? 0 : 0.7}` }}>
          <ModalHeader
            onClick={() => {
              setFileDiffsModal(false);
              setPublish(false);
            }}
            icon={<FiArrowLeft className='cursor-pointer' />}
            title={publish ? "Pubblica modifiche" : "Storia delle modifiche"}
          />
          {!publish && (
            <div className='flex'>
              <div className='flex flex-1 items-center py-2 px-3 text-black dark:text-white'>
                <FiUser className='mr-1' />
                <span className='text-xs uppercase'>
                  {diffs.original.author} - {diffs.original.dateModified}
                </span>
              </div>
              <div className='flex flex-1 items-center py-2 px-3 text-black dark:text-white'>
                <FiUser className='mr-1' />
                <span className='text-xs uppercase'>
                  {diffs.modified.author} - {diffs.modified.dateModified}
                </span>
              </div>
            </div>
          )}
          <div className='max-h-[calc(100vh-250px)] overflow-auto'>
            <DiffEditor
              language='vb'
              original={diffs.original.code}
              modified={diffs.modified.code}
              theme={darkMode ? "vs-dark" : "vs-light"}
              height={publish ? "calc(70vh - 100px)" : "70vh"}
              options={{
                selectOnLineNumbers: true,
                readOnly: true,
                fontSize: 13,
              }}
            />
            {publish && (
              <div className='py-2 px-3'>
                <textarea
                  className='w-full mt-4 p-3 resize-none rounded-lg bg-black-050 text-sm text-black dark:bg-black-950 dark:text-white'
                  onChange={({ target }) => setPublishNotes(target.value)}
                  rows={4}
                  placeholder='Descrivi le modifiche apportate alla pagina'></textarea>
              </div>
            )}
          </div>
          {publish && (
            <ModalFooter>
              <ModalButton type='primary' text='Pubblica modifiche' onClick={publishFile} />
              <ModalButton
                text='Annulla'
                onClick={() => {
                  setFileDiffsModal(false);
                  setPublish(false);
                }}
              />
            </ModalFooter>
          )}
        </Modal>
      )}

      {filePublishedModal && (
        <div className='fixed top-0 left-0 w-full h-screen flex items-center justify-center'>
          <div className='fixed w-full h-screen bg-[rgba(0,0,0,0.7)]' onClick={() => setFilePublishedModal(false)}></div>
          <div className='bg-white dark:bg-black rounded-lg z-[1] max-w-[90%] min-w-[600px] animate-zoom-in'>
            <ModalHeader icon={<FiCheck />} title='Pagina pubblicata' />
            <div className='flex flex-col items-center justify-center p-3'>
              <img className='p-3 w-32' src={ConfirmedImg} />
              <div className='p-3 text-base text-black dark:text-white'>Pagina pubblicata con successo.</div>
            </div>
            <ModalFooter>
              <ModalButton text='Chiudi' onClick={() => setFilePublishedModal(false)} />
            </ModalFooter>
          </div>
        </div>
      )}

      {fileUploadModal && (
        <Modal type='md' title='Carica file' onDismiss={() => setFileUploadModal(false)}>
          <div className='flex flex-col items-center justify-center p-3'>
            {!uploading && <input onChange={uploadFile} data-role='uploader' type='file' />}
            {uploading && (
              <div className='flex flex-col items-center justify-center p-4'>
                <img className='p-3 w-32' src={UploadImg} />
                <div className='p-3 text-base text-black dark:text-white'>Caricamento file in corso: {uploadPercentage}%</div>
                {uploadPercentage === 100 && <div className='p-3 text-base text-black dark:text-white'>Copia del file in corso...</div>}
              </div>
            )}
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setFileUploadModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {discardChangesModal && (
        <Modal onDismiss={() => setDiscardChangesModal(false)}>
          <ModalHeader icon={<FiEdit />} title='Annulla modifiche' />
          <div className='p-3 text-black dark:text-white'>
            Vuoi veramente chiudere la pagina annullando le modifiche? Verrà ripristinato il codice alla data in cui è stato aperto il file.
          </div>
          <ModalFooter>
            <ModalButton type='danger' text='Sì, annulla le modifiche' onClick={() => discardChanges()} />
            <ModalButton text='No, continua a modificare' onClick={() => setDiscardChangesModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {previewModal && (
        <Modal type='md' onDismiss={() => setPreviewModal(false)}>
          <header className='flex items-center py-4 px-3 font-semibold border-b border-black-200 text-white dark:border-black-800 dark:text-white'>
            Anteprima
            <button
              className='ml-2 w-8 h-8 bg-blue-200 text-blue rounded-lg flex items-center justify-center hover:bg-blue hover:text-white transition-all'
              onClick={() => window.open(`${previewFile.path}&download=yes`, "_blank")}>
              <FiDownload />
            </button>
          </header>
          <div className='flex items-center justify-center p-3 max-h-[calc(100vh-250px)]'>
            {previewFile.type === "image" && <img className='object-contain max-h-[80vh] max-w-[90%] bg-black-100 dark:bg-black-900' src={previewFile.path} />}
            {previewFile.type === "pdf" && <object className='w-[80vw] h-[70vh]' data={previewFile.path}></object>}
            {previewFile.type === "video" && <video controls className='w-[45vw] bg-black-100 dark:bg-black-900 aspect-video' src={previewFile.path} />}
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setPreviewModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {status !== "Pronto" && status !== "Salvataggio in corso..." && (
        <Modal>
          <div className='flex items-center justify-center p-6'>
            <div className='flex items-center justify-center text-black dark:text-white'>
              <Spinner size={9} color='blue' />
              <div className='mx-4'>
                <h4 className='mb-1'>Attendere prego...</h4>
                <span className='text-sm text-black-700 dark:text-black-400'>{status}</span>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {fileContextMenu && (
        <div id='fileContextMenu' ref={fileContextMenuRef}>
          <ContextMenu top={fileContextMenuPosition.top} left={fileContextMenuPosition.left}>
            <ContextMenuItem onClick={() => window.open(`${window.localStorage.getItem("companyDomain")}download.asp?download=yes&path=${fileContextMenu}`)}>
              <FiDownload /> Scarica file
            </ContextMenuItem>
            {isSupported(fileContextMenu) && (
              <ContextMenuItem onClick={() => openFile(fileContextMenu, false)}>
                <FiEye /> Apri in sola lettura
              </ContextMenuItem>
            )}
            <ContextMenuItem
              onClick={() => {
                setRenameFileModal(true);
                setOldFileName(fileContextMenu.replace(`${currentPath}/`, ""));
                setNewFileName(fileContextMenu.replace(`${currentPath}/`, ""));
              }}>
              <FiEdit /> Rinomina
            </ContextMenuItem>
            <ContextMenuItem
              type='danger'
              onClick={() => {
                setRemoveFileModal(true);
                setRemoveFilePath(fileContextMenu.replace(`${currentPath}/`, ""));
              }}>
              <FiTrash2 /> Elimina
            </ContextMenuItem>
          </ContextMenu>
        </div>
      )}

      {folderContextMenu && (
        <div id='folderContextMenu' ref={folderContextMenuRef}>
          <ContextMenu top={folderContextMenuPosition.top} left={folderContextMenuPosition.left}>
            <ContextMenuItem
              onClick={async () => {
                await SAFM.cloneFolder(currentPath, folderContextMenu);
                browse(currentPath);
              }}>
              <FiCopy /> Duplica
            </ContextMenuItem>
            <ContextMenuItem
              onClick={() => {
                setRenameFolderModal(true);
                setOldFolderName(folderContextMenu);
                setNewFolderName(folderContextMenu);
              }}>
              <FiEdit /> Rinomina
            </ContextMenuItem>
            <ContextMenuItem
              type='danger'
              onClick={() => {
                setRemoveFolderModal(true);
                setRemoveFolderPath(folderContextMenu);
              }}>
              <FiTrash2 /> Elimina
            </ContextMenuItem>
          </ContextMenu>
        </div>
      )}

      {pathModal && (
        <div className='fixed top-1 left-[50%] translate-x-[-50%] w-96 h-9 bg-white shadow-[0px_0px_10px_rgba(0,0,0,0.15)] animate-slide-up dark:bg-black'>
          <input
            className='w-full h-full px-2 bg-transparent text-sm text-black dark:text-white focus:outline-0'
            onKeyPress={(e) => (e.key === "Enter" ? browse(`${getDomainByPath(currentPath)}/${e.currentTarget.value}`) : null)}
            autoFocus
            type='text'
            placeholder='Vai alla cartella...'></input>
        </div>
      )}

      {tablesModal && (
        <Modal type='md' title='Lista tabelle SQL' onDismiss={() => setTablesModal(false)}>
          <div className='text-white min-w-[55vw] max-w-[55vw] min-h-[60vh] max-h-[60vh] overflow-auto'>
            <div className='m-3'>
              <ModalInput full type='search' placeholder='Cerca tabella...' onChange={(e) => filterTables(e.target.value)} />
            </div>

            <table className='text-black dark:text-white dark:bg-black w-full'>
              <thead>
                <tr className='h-8'>
                  {listOfTables.columns.map(({ name }) => (
                    <td className='text-sm text-left border-r border-b border-black-200 px-3 dark:text-white dark:border-black-800' key={name}>
                      <b>{name}</b>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredListOfTables.data.map((row, i) => (
                  <tr className={`${i % 2 ? "bg-black-050 dark:bg-black-950" : "bg-white dark:bg-black"} hover:bg-blue-200 transition-all`} key={i}>
                    {row.map((field, i) => (
                      <td className='text-sm h-8 px-3' key={i}>
                        {i === 0 && (
                          <a className='flex items-center text-blue cursor-pointer' onClick={() => showTableStructure(field)}>
                            {field}
                          </a>
                        )}
                        {i > 0 && i < 2 && field}
                        {i === 2 && (
                          <a className='flex items-center text-blue cursor-pointer' onClick={() => showTop1000(field)}>
                            <FiSearch className='mr-1' /> Estrai le prime 100 righe
                          </a>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setTablesModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {fieldsModal && (
        <Modal type='md' title={`Struttura tabella - ${selectedTable}`} onDismiss={() => setFieldsModal(false)}>
          <div className='flex max-h-[calc(100vh-250px)] overflow-auto'>
            <table className='text-black dark:text-white dark:bg-black w-full'>
              <thead>
                <tr className='h-8'>
                  {listOfFields.columns.map(({ name }) => (
                    <td className='text-sm text-left border-r border-b border-black-200 px-3 dark:border-black-800' key={name}>
                      <b>{name}</b>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {listOfFields.data.map((row, i) => (
                  <tr className={`${i % 2 ? "bg-black-050 dark:bg-black-950" : "bg-white dark:bg-black"} hover:bg-blue-200 transition-all`} key={i}>
                    {row.map((field, i) => (
                      <td className='text-sm h-8 px-3' key={i}>
                        {i === 0 && field.split(";").length > 1 && (
                          <span className='flex items-center'>
                            <FiKey className='mr-1 text-gold' /> {field.split(";")[0]}
                          </span>
                        )}
                        {((i === 0 && field.split(";").length === 1) || (i > 0 && i < 2)) && field}
                        {i === 2 && field === "YES" && <FiCheckSquare />}
                        {i === 2 && field === "NO" && <FiSquare />}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setFieldsModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {top1000Modal && (
        <Modal type='md' title={`Struttura tabella - ${selectedTable}`} onDismiss={() => setTop1000Modal(false)}>
          <div className='flex max-h-[calc(100vh-250px)] overflow-auto'>
            <table className='text-black dark:text-white dark:bg-black w-full'>
              <thead>
                <tr className='h-8'>
                  {listOfTop1000.columns.map(({ name }) => (
                    <td className='text-sm text-left border-r border-b border-black-200 px-3 dark:border-black-800' key={name}>
                      <b>{name}</b>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {listOfTop1000.data.map((row, i) => (
                  <tr className={`${i % 2 ? "bg-black-050 dark:bg-black-950" : "bg-white dark:bg-black"} hover:bg-blue-200 transition-all`} key={i}>
                    {row.map((item, i) => (
                      <td className='text-sm h-8 px-3' key={i}>
                        {item}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setTop1000Modal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {settingsModal && (
        <Modal type='md' title='Impostazioni account' onDismiss={() => setSettingsModal(false)}>
          <div className='flex flex-col max-h-[calc(100vh-250px)] p-3 overflow-auto'>
            <div
              className='h-20 w-20 text-2xl flex items-center justify-center rounded-full text-white'
              style={{ background: SAFM.generateColor(SAFM.getUserObject().dusr) }}>
              <span>{SAFM.getUserObject().dusr.substr(0, 1)}</span>
            </div>
            <form>
              {/* form per evitare warning di Chrome per campi input[type="password"] che non sono contenuti in un tag form */}
              <InputField title='Codice utente' value={SAFM.getUserObject().usr} disabled />
              <InputField title='Descrizione' value={SAFM.getUserObject().dusr} disabled />
              <div className='relative flex flex-col my-4 w-full'>
                <label className='px-2 mb-1 text-sm text-black-700 dark:text-black-400'>
                  Password
                  <a className='ml-2 text-blue cursor-pointer hover:opacity-70 transition-all' onClick={() => setPasswordModal(true)}>
                    Cambia Password
                  </a>
                </label>
                <input
                  className='h-12 rounded-lg px-2 bg-black-050 dark:bg-black-900 text-black dark:text-white leading-[1px] tracking-widest'
                  value='password'
                  type='password'
                  disabled
                />
              </div>
              <InputField
                title='Doppia autenticazione'
                type='select'
                value={otp}
                options={[
                  { value: "N", description: "Disattivata" },
                  { value: "S", description: "Attivata (solo cambio postazione)" },
                  { value: "X", description: "Attivata ad ogni accesso" },
                ]}
                onChange={({ target }) => setOtp(target.value)}
              />
              <InputField title='Cellulare (doppia autenticazione)' value={phoneNumber} onChange={({ target }) => setPhoneNumber(target.value)} type='tel' />
            </form>
          </div>
          <ModalFooter>
            <ModalButton type='primary' text='Salva impostazioni' onClick={saveSettings} />
            <ModalButton text='Chiudi' onClick={() => setSettingsModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {passwordModal && (
        <Modal type='md' title='Cambia password' onDismiss={() => setPasswordModal(false)}>
          <div className='flex flex-col max-h-[calc(100vh-250px)] p-3 overflow-auto'>
            <form>
              <InputField
                value={currentPassword}
                onChange={({ target }) => setCurrentPassword(target.value)}
                placeholder='Inserisci la password corrente'
                type='password'
              />
              <InputField
                value={newPassword}
                onChange={({ target }) => setNewPassword(target.value)}
                placeholder='Inserisci la nuova password'
                type='password'
              />
              <InputField
                value={repeatPassword}
                onChange={({ target }) => setRepeatPassword(target.value)}
                placeholder='Ripeti la nuova password'
                type='password'
              />
            </form>
          </div>
          <ModalFooter>
            <ModalButton type='primary' text='Conferma password' onClick={changePassword} />
            <ModalButton text='Chiudi' onClick={() => setPasswordModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {promptModal && (
        <Modal title={promptTitle} onDismiss={() => setPromptModal(false)}>
          <div className='flex items-center max-h-[calc(100vh-250px)] p-6 overflow-auto'>
            {promptResult ? <FiCheckCircle className='text-3xl mr-4 text-green' /> : <FiXCircle className='text-3xl mr-4 text-red' />}
            <span className='dark:text-white'>{promptMessage}</span>
          </div>
          <ModalFooter>
            <ModalButton text='Chiudi' onClick={() => setPromptModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      {searchTextModal && (
        <Modal title='Ricerca testo contenuto nelle pagine' onDismiss={() => setSearchTextModal(false)}>
          <div className='flex flex-col items-center max-h-[calc(100vh-250px)] p-3 overflow-auto'>
            <span className='text-sm dark:text-white'>Permette di trovare tutte le pagine contenenti del testo specificato nel campo di ricerca</span>
            <textarea
              className='w-full my-2 mt-4 p-3 rounded-lg bg-black-050 text-black resize-none dark:bg-black-950 dark:text-white'
              value={text}
              onChange={({ target }) => setText(target.value)}
              rows={4}></textarea>
          </div>
          <ModalFooter>
            <ModalButton type='primary' text='Cerca' onClick={searchText} />
            <ModalButton text='Chiudi' onClick={() => setSearchTextModal(false)} />
          </ModalFooter>
        </Modal>
      )}

      <div className='hidden' id='status-bar'>
        {isOnline && (
          <div className='h-6 flex items-center px-2 text-white text-xs z-[9999] bg-gradient-to-r from-blue to-aqua bottom-0 w-full select-none'>
            <span>{status}</span>
          </div>
        )}

        {!isOnline && <div className='h-6 flex items-center px-2 text-black text-xs z-[9999] bg-red bottom-0 w-full select-none'>Modalità offline</div>}
      </div>
    </div>
  );
};

export default Home;
